import React from "react";
import { Check, Zap } from "lucide-react";

const packages = [
  {
    id: "basic",
    name: "Basic",
    tagline: "Daily driver refresh",
    price: "149",
    duration: "2–3 hrs",
    features: [
      "Hand wash & dry",
      "Wheels & tires detailed",
      "Bug & tar removal",
      "Interior vacuum",
      "Dashboard & console wipe-down",
      "Windows inside & out",
      "Tire shine",
    ],
    featured: false,
  },
  {
    id: "premium",
    name: "Premium",
    tagline: "The weekend show-off",
    price: "349",
    duration: "5–6 hrs",
    features: [
      "Everything in Basic",
      "Clay bar decontamination",
      "One-step polish",
      "6-month paint sealant",
      "Interior steam clean",
      "Leather condition & UV protect",
      "Door jambs & fuel cap detail",
      "Engine bay light detail",
    ],
    featured: true,
  },
  {
    id: "ultimate",
    name: "Ultimate",
    tagline: "Concours-level care",
    price: "799",
    duration: "1–2 days",
    features: [
      "Everything in Premium",
      "Multi-stage paint correction",
      "2-year ceramic coating",
      "Wheels off deep detail",
      "Headlight restoration",
      "Full interior shampoo & extract",
      "Odor elimination treatment",
      "Scotchgard fabric protection",
      "Complimentary 30-day check-up",
    ],
    featured: false,
  },
];

export default function Packages() {
  return (
    <section
      id="packages"
      data-testid="packages-section"
      className="relative py-24 md:py-32 bg-[#070707]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="w-12 h-px bg-red-500" />
            <span className="text-xs tracking-[0.3em] uppercase text-red-500 font-bold">
              Signature Packages
            </span>
            <span className="w-12 h-px bg-red-500" />
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter">
            Three tiers. <br />
            <span className="text-zinc-600">Zero compromise.</span>
          </h2>
          <p className="mt-6 text-zinc-400 text-base md:text-lg leading-relaxed">
            Transparent, flat-rate pricing — no gimmicks. Starting points for
            sedans; trucks, SUVs, and exotics quoted on request.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {packages.map((p) => (
            <article
              key={p.id}
              data-testid={`package-card-${p.id}`}
              className={`relative h-full flex flex-col p-8 md:p-10 border transition-all duration-500 ${
                p.featured
                  ? "bg-zinc-900 border-red-500/60 shadow-[0_0_60px_rgba(255,59,48,0.12)]"
                  : "bg-zinc-950 border-zinc-900 hover:border-zinc-700"
              }`}
            >
              {p.featured && (
                <span className="absolute -top-3 left-8 bg-red-500 text-white text-[10px] font-bold tracking-[0.25em] uppercase px-3 py-1 inline-flex items-center gap-1">
                  <Zap size={10} /> Most Chosen
                </span>
              )}

              <div className="flex items-center justify-between">
                <span className="text-xs tracking-[0.3em] uppercase text-zinc-500">
                  Tier 0{packages.indexOf(p) + 1}
                </span>
                <span className="text-xs text-zinc-500">{p.duration}</span>
              </div>

              <h3 className="font-display text-5xl md:text-6xl uppercase tracking-tighter mt-6">
                {p.name}
              </h3>
              <p className="text-zinc-500 mt-2 text-sm">{p.tagline}</p>

              <div className="mt-8 flex items-baseline gap-2">
                <span className="text-zinc-500 text-lg">$</span>
                <span className="font-display text-6xl tracking-tighter">
                  {p.price}
                </span>
                <span className="text-zinc-500 text-sm">/ starting</span>
              </div>

              <ul className="mt-10 space-y-4 flex-grow">
                {p.features.map((f, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 text-sm text-zinc-300"
                  >
                    <Check
                      size={16}
                      className={
                        p.featured ? "text-red-500 mt-0.5" : "text-zinc-500 mt-0.5"
                      }
                    />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#contact"
                data-testid={`package-cta-${p.id}`}
                className={`mt-10 inline-flex items-center justify-center px-6 py-4 font-bold text-xs tracking-[0.25em] uppercase transition-all duration-300 ${
                  p.featured
                    ? "bg-red-500 hover:bg-red-400 text-white"
                    : "border border-zinc-700 hover:border-red-500 text-white"
                }`}
              >
                Request Booking
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
